( function ( $ ) {
	class Tabs {

		/**
		 * Constructor.
		 *
		 * @return {void}
		 */
		constructor() {
			this.tabHeadings = $('.ebayads-tab-heading-wrap');
			this.addEvents();
		}

		/**
		 * Add Events.
		 *
		 * @return {void}
		 */
		addEvents() {

			this.tabHeadings.on( 'click mouseover', ( event ) => this.setElementActive( event ) );

		}

		setElementActive( event ) {
			const targetEl = this.getTargetElement( $( event.target ) );
			const targetClass = targetEl.attr( 'data-attr-class' );
			const targetParentId = targetEl.attr( 'data-attr-parent-id' );
			const targetElSelector = `${ targetParentId } ${ targetClass }`;

			// If clicked element is already active dont do anything.
			if ( targetEl.hasClass( 'active' ) ) {
				return;
			}

			this.headingElsToToggle = $( `${ targetParentId } .ebayads-tab-content` );
			this.contentElsToToggle = $( `${ targetParentId } .ebayads-tab-heading-wrap` );

			// First hide all elements.
			this.headingElsToToggle.removeClass( 'active' );
			this.contentElsToToggle.removeClass( 'active' );

			// Then show the target element.
			$( targetElSelector ).addClass( 'active' );
		}

		/**
		 * Get the target element.
		 *
		 * @param eventTarget
		 * @return {null|any|Element}
		 */
		getTargetElement( eventTarget ) {

			if ( eventTarget.hasClass( 'ebayads-tab-heading-wrap' ) ) {
				return eventTarget;
			} else {
				return eventTarget.closest( '.ebayads-tab-heading-wrap' );
			}
		}

	}

	new Tabs();

} )( jQuery );
